module.exports = __webpack_public_path__ + "icon-mockito.2h-4chDs.svg";